module.exports = "/virtual-football-league/img/amblems/left/Spain/Fake_AtleticoBilbao.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Spain/Fake_AtleticoBilbao.png
// module id = 2044
// module chunks = 4